"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Function to return value from querystring
 * @param {Location} location
 * @param {string} name
 * @returns {string}
 */

function getQueryValue(location, queryName) {
  var testedName = queryName.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp("[\\?&]".concat(testedName, "=([^&#]*)"));
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

exports.default = getQueryValue || '';